var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IMAGES } from 'renderer/assets';
import { BaseModel } from './BaseModel';
import { SalesHistoryModel } from './SalesHistoryModel';
import { ScheduleModel } from './ScheduleModel';
import * as dayjs from 'dayjs';
import { getProductByIdFromCacheObject } from 'renderer/queries/product';
import { KRWFomatToString } from 'renderer/components';
import { isEmpty } from 'renderer/utils';
export var CUSTOMER_HISTORY_TYPE;
(function (CUSTOMER_HISTORY_TYPE) {
    CUSTOMER_HISTORY_TYPE["SCHEDULE"] = "schedule";
    CUSTOMER_HISTORY_TYPE["SALES"] = "sales";
})(CUSTOMER_HISTORY_TYPE || (CUSTOMER_HISTORY_TYPE = {}));
var CustomerHistoryModel = /** @class */ (function (_super) {
    __extends(CustomerHistoryModel, _super);
    function CustomerHistoryModel(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.type = props.type;
        _this.id = props.id;
        _this.date = props.date;
        if (_this.type === CUSTOMER_HISTORY_TYPE.SCHEDULE) {
            var salesHistory = _this.data.salesHistory;
            _this.data = new ScheduleModel(_this.data);
            _this.data.storeProducts = ((_a = _this.data.storeScheduleProducts) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
                var storeProductId = _a.storeProductId;
                return getProductByIdFromCacheObject(_this.data.storeId, storeProductId);
            })) || [];
            if (salesHistory) {
                _this.data.salesHistory = new SalesHistoryModel(salesHistory);
                _this.data.salesHistory.meta.pictures = salesHistory['pictures'] || [];
            }
        }
        else {
            _this.data = new SalesHistoryModel(_this.data);
        }
        return _this;
    }
    Object.defineProperty(CustomerHistoryModel.prototype, "isSchedule", {
        /**
         * 현재 히스토리가 schedule인지 확인
         * @returns {boolean} schedule 여부
         */
        get: function () {
            return this.type === CUSTOMER_HISTORY_TYPE.SCHEDULE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerHistoryModel.prototype, "isCompleted", {
        /**
         * 완료 여부 확인
         * - `schedule`이면 `data.endedAt`을 기준으로 현재 시간과 비교하여 완료 여부 반환
         * - `sales`이면 `date`를 기준으로 현재 시간과 비교하여 완료 여부 반환
         * @returns {boolean} 완료 여부 (true = 완료됨)
         */
        get: function () {
            var now = dayjs();
            if (this.isSchedule) {
                var endedAt = this.data.dateOption.endedAt;
                return endedAt ? dayjs(endedAt).isBefore(now) : false;
            }
            return dayjs(this.date).isBefore(now);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerHistoryModel.prototype, "historyType", {
        /**
         * 히스토리 유형 반환
         * - 예약(SCHEDULE)일 경우 "예약"
         * - 매출(SALES)일 경우 totalPrice 값에 따라 "환불" 또는 "매출" 반환
         * @returns {string} "예약", "환불", "매출" 중 하나
         *
         * FIXME: `totalPrice`로 환불 여부를 확인하는 것이 정확한지 검토 필요
         * - 보다 확실한 상태 값이 존재하는지 확인해야 함
         */
        get: function () {
            if (this.isSchedule) {
                return '예약';
            }
            var totalPrice = this.data.totalPrice;
            return totalPrice < 0 ? '환불' : '매출';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerHistoryModel.prototype, "historyIcon", {
        /**
         * 히스토리 유형에 따라 적절한 아이콘 반환
         * - 예약(SCHEDULE)이고 `data.from`이 'naver'이면 네이버 아이콘
         * - 예약(SCHEDULE)이고 `data.from`이 네이버가 아니면 기본 아이콘
         * - 그 외에는 선물 아이콘 반환
         * @returns {string} 이미지 경로
         */
        get: function () {
            if (this.isSchedule) {
                return this.data.from === 'naver'
                    ? IMAGES.naver_logo_icon_12
                    : IMAGES.thinkofyou_logo_icon_12;
            }
            return IMAGES.gift_icon_12;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 매출 데이터를 받아 `saleListString`, `data?.prevSalesContent`, `typeString` 중
     * 가장 먼저 존재하는 값을 반환
     *
     * @param {SalesHistoryModel} salesData - 매출 데이터
     * @returns {string} 매출 정보 문자열
     */
    CustomerHistoryModel.getFormattedSalesInfo = function (salesData) {
        var _a;
        return salesData.saleListString || ((_a = salesData.data) === null || _a === void 0 ? void 0 : _a.prevSalesContent) || salesData.typeString;
    };
    Object.defineProperty(CustomerHistoryModel.prototype, "historyDetail", {
        /**
         * 히스토리 상세 정보 반환
         * - 예약(SCHEDULE)일 경우 `data.usingString`
         * - 매출(SALES)일 경우 `data.saleListString || data.data?.prevSalesContent || data.typeString`
         * @returns {string} 히스토리 상세 정보
         */
        get: function () {
            if (this.isSchedule) {
                return this.data.usingString;
            }
            return CustomerHistoryModel.getFormattedSalesInfo(this.data);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerHistoryModel.prototype, "formattedScheduleTime", {
        /**
         * 예약 시간을 "11:30 ~ 12:30 예약" 형태로 반환
         * @returns {string} 예약 시간 문자열 (스케줄이 아닐 경우 빈 문자열)
         */
        get: function () {
            if (this.isSchedule) {
                var scheduleData = this.data;
                var _a = scheduleData.dateOption, startedAt = _a.startedAt, endedAt = _a.endedAt;
                return "".concat(dayjs(startedAt).format('HH:mm'), " ~ ").concat(dayjs(endedAt).format('HH:mm'), " \uC608\uC57D");
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerHistoryModel.prototype, "formattedDescription", {
        /**
         * 예약(SCHEDULE)이면 `data.description`을, 매출(SALES)이면 `data.memo`를 반환
         * @returns {string} 설명 또는 메모
         */
        get: function () {
            return this.isSchedule ? this.data.description : this.data.memo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerHistoryModel.prototype, "salesHistory", {
        /**
         * 예약(SCHEDULE)일 경우 `data.salesHistory` 반환
         * - 매출(SALES)일 경우 `undefined` 반환
         * @returns {SalesHistoryModel | undefined} `salesHistory` 객체 또는 `undefined`
         */
        get: function () {
            return this.isSchedule ? this.data.salesHistory : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerHistoryModel.prototype, "formattedTotalPrice", {
        /**
         * 총 매출 금액을 형식화하여 반환
         * - 예약(SCHEDULE)일 경우:
         *   - `data.salesHistory.totalPrice` 값이 존재하면 해당 값을 반환
         *   - `data.salesHistory`가 없으면 `storeProducts` 배열의 `price` 총합을 계산하여 반환
         * - 매출(SALES)일 경우 `data.totalPrice` 반환
         * @returns {string} 형식화된 총 매출 금액 (KRW)
         */
        get: function () {
            if (this.isSchedule) {
                var salesHistory = this.data.salesHistory;
                if (salesHistory) {
                    return KRWFomatToString({ value: salesHistory.totalPrice });
                }
                else {
                    var storeProducts = this.data.storeProducts;
                    var totalPrice = isEmpty(storeProducts) ? 0 : storeProducts.reduce(function (sum, product) { var _a; return sum + ((_a = product.price) !== null && _a !== void 0 ? _a : 0); }, 0);
                    return KRWFomatToString({ value: totalPrice });
                }
            }
            return KRWFomatToString({ value: this.data.totalPrice });
        },
        enumerable: false,
        configurable: true
    });
    return CustomerHistoryModel;
}(BaseModel));
export { CustomerHistoryModel };
